import type * as Types from '../../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type GetSharryContentCardBookmarkedQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetSharryContentCardBookmarkedQuery = {
  __typename?: 'Query';
  sharryContent?:
    | { __typename?: 'Event'; id: string; slug?: string | null; bookmarked?: boolean | null }
    | {
        __typename?: 'Post';
        id: string;
        slug?: string | null;
        bookmarked?: boolean | null;
      }
    | { __typename?: 'Sharry'; id: string; slug?: string | null; bookmarked?: boolean | null }
    | {
        __typename?: 'Wonder';
        id: string;
        slug?: string | null;
        bookmarked?: boolean | null;
      }
    | null;
};

export type GetUserCardBookmarkedQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetUserCardBookmarkedQuery = {
  __typename?: 'Query';
  user?: { __typename?: 'User'; id: string; bookmarked?: boolean | null } | null;
};

export const GetSharryContentCardBookmarkedDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSharryContentCardBookmarked' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'bookmarked' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetSharryContentCardBookmarkedGQL extends Apollo.Query<
  GetSharryContentCardBookmarkedQuery,
  GetSharryContentCardBookmarkedQueryVariables
> {
  document = GetSharryContentCardBookmarkedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetUserCardBookmarkedDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserCardBookmarked' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookmarked' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetUserCardBookmarkedGQL extends Apollo.Query<
  GetUserCardBookmarkedQuery,
  GetUserCardBookmarkedQueryVariables
> {
  document = GetUserCardBookmarkedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
